// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__J7yLS","colMaxWidth":"Table_colMaxWidth__2kiU5"};